var ClientPlatform;

(function (ClientPlatform) {
  ClientPlatform["Web"] = "web";
  ClientPlatform["WebLocal"] = "web-local";
})(ClientPlatform || (ClientPlatform = {}));

export default ClientPlatform;